// extracted by mini-css-extract-plugin
export var answer = "question-and-answer-module--answer--RVSSi";
export var container = "question-and-answer-module--container--tQzgT";
export var containerOpen = "question-and-answer-module--container--open--W0VJL";
export var icon = "question-and-answer-module--icon--eqVKo";
export var innerContainer = "question-and-answer-module--innerContainer--ZvQxE";
export var question = "question-and-answer-module--question--tVQ5Y";